import { ArrowUpRight } from 'lucide-react'
import type { ButtonHTMLAttributes, ComponentProps } from 'react'
import { LocalizedLink } from '@/components/LocalizedLink'
export function Button({ className = '', variant = 'primary', ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'primary' | 'secondary' }) {
  return <button type="button" className={`medika-button medika-button--${variant} ${className}`} {...props} />
}
export function ButtonLink({ className = '', variant = 'primary', children, ...props }: ComponentProps<typeof LocalizedLink> & { variant?: 'primary' | 'secondary' }) {
  return <LocalizedLink className={`medika-button medika-button--${variant} medika-button--directional ${className}`} {...props}><span>{children}</span><span className="button-direction" aria-hidden="true"><ArrowUpRight /></span></LocalizedLink>
}
